"use strict";
// This optional code is used to register a service worker.
// register() is not called by default.
Object.defineProperty(exports, "__esModule", { value: true });
exports.showNotification = exports.initializeServiceWorker = exports.serviceWorkerRegistration = exports.serviceWorkerRegister = void 0;
exports.unregister = unregister;
var tslib_1 = require("tslib");
var envConfigBase_1 = require("../envConfig/envConfigBase");
var serviceWorkerRegister = function (config) {
    if ('serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        var publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
        if (publicUrl.origin !== window.location.origin) {
            // Our service worker won't work if PUBLIC_URL is on a different origin
            // from what our page is served on. This might happen if a CDN is used to
            // serve assets; see https://github.com/facebook/create-react-app/issues/2374
            return;
        }
        window.addEventListener('load', function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var swUrl, error_1;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        swUrl = (config === null || config === void 0 ? void 0 : config.isLocalEnv)
                            ? "".concat(process.env.PUBLIC_URL, "/service-worker-local.js")
                            : "".concat(process.env.PUBLIC_URL, "/service-worker.js");
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        if (!(config === null || config === void 0 ? void 0 : config.isLocalEnv)) return [3 /*break*/, 3];
                        // This is running on localhost. Let's check if a service worker still exists or not.
                        return [4 /*yield*/, checkValidServiceWorker(swUrl, config)
                            // Add some additional logging to localhost, pointing developers to the
                            // service worker/PWA documentation.
                        ];
                    case 2:
                        // This is running on localhost. Let's check if a service worker still exists or not.
                        _b.sent();
                        // Add some additional logging to localhost, pointing developers to the
                        // service worker/PWA documentation.
                        navigator.serviceWorker.ready.then(function (registration) {
                            var _a;
                            (_a = config.onSuccess) === null || _a === void 0 ? void 0 : _a.call(config, registration);
                            console.log('This web app is being served cache-first by a service ' +
                                'worker. To learn more, visit https://bit.ly/CRA-PWA');
                        });
                        return [3 /*break*/, 5];
                    case 3: 
                    // Is not localhost. Just register service worker
                    return [4 /*yield*/, registerValidSW(swUrl, config)];
                    case 4:
                        // Is not localhost. Just register service worker
                        _b.sent();
                        _b.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_1 = _b.sent();
                        (_a = config === null || config === void 0 ? void 0 : config.onError) === null || _a === void 0 ? void 0 : _a.call(config, error_1);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); });
    }
};
exports.serviceWorkerRegister = serviceWorkerRegister;
function registerValidSW(swUrl, config) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var registration;
        var _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, navigator.serviceWorker.register(swUrl)];
                case 1:
                    registration = _c.sent();
                    if (((_a = registration.active) === null || _a === void 0 ? void 0 : _a.state) === 'activated') {
                        (_b = config === null || config === void 0 ? void 0 : config.onSuccess) === null || _b === void 0 ? void 0 : _b.call(config, registration);
                    }
                    registration.onupdatefound = function () {
                        var installingWorker = registration.installing;
                        if (installingWorker == null) {
                            return;
                        }
                        installingWorker.onstatechange = function () {
                            if (installingWorker.state === 'installed') {
                                if (navigator.serviceWorker.controller) {
                                    // At this point, the updated precached content has been fetched,
                                    // but the previous service worker will still serve the older
                                    // content until all client tabs are closed.
                                    console.log('New content is available and will be used when all ' +
                                        'tabs for this page are closed. See https://bit.ly/CRA-PWA.');
                                    // Execute callback
                                    if (config && config.onUpdate) {
                                        config.onUpdate(registration);
                                    }
                                }
                                else {
                                    // At this point, everything has been precached.
                                    // It's the perfect time to display a
                                    // "Content is cached for offline use." message.
                                    console.log('Content is cached for offline use.');
                                    // Execute callback
                                    // original code, unsure why we would have to wait this far to call on success
                                    // if (config && config.onSuccess) {
                                    //   config.onSuccess(registration)
                                    // }
                                }
                            }
                        };
                    };
                    return [2 /*return*/];
            }
        });
    });
}
function checkValidServiceWorker(swUrl, config) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, contentType;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(swUrl, {
                        headers: { 'Service-Worker': 'script' },
                    })
                    // Ensure service worker exists, and that we really are getting a JS file.
                ];
                case 1:
                    response = _a.sent();
                    contentType = response.headers.get('content-type');
                    if (!(response.status === 404 ||
                        (contentType != null && contentType.indexOf('javascript') === -1))) return [3 /*break*/, 2];
                    // No service worker found. Probably a different app. Reload the page.
                    navigator.serviceWorker.ready.then(function (registration) {
                        registration.unregister().then(function () {
                            window.location.reload();
                        });
                    });
                    return [3 /*break*/, 4];
                case 2: 
                // Service worker found. Proceed as normal.
                return [4 /*yield*/, registerValidSW(swUrl, config)];
                case 3:
                    // Service worker found. Proceed as normal.
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
            .then(function (registration) {
            registration.unregister();
        })
            .catch(function (error) {
            console.error(error.message);
        });
    }
}
exports.serviceWorkerRegistration = {
    showNotification: undefined,
};
var initializeServiceWorker = function () {
    (0, exports.serviceWorkerRegister)({
        isLocalEnv: (0, envConfigBase_1.envConfigBase)().environment === 'local',
    });
    navigator.serviceWorker.ready.then(function (registration) {
        exports.serviceWorkerRegistration.showNotification = registration.showNotification;
    });
};
exports.initializeServiceWorker = initializeServiceWorker;
var showNotification = function (title, options) {
    if (exports.serviceWorkerRegistration.showNotification) {
        exports.serviceWorkerRegistration.showNotification(title, options);
    }
    else {
        new Notification(title, options);
    }
};
exports.showNotification = showNotification;
